import React from 'react';
import { Box, CircularProgress } from '@mui/material';

/**
 * 通用页面级加载占位：用于 React.lazy 路由分包加载与认证探测期间的加载态，
 * 避免整页白屏。
 */
export function PageLoading() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        minHeight: '40vh',
        gap: 1,
      }}
    >
      <CircularProgress size={32} />
    </Box>
  );
}

export default PageLoading;
